<x-chartist [type]="'Line'" [data]="scatterData" [options]="scatterOptions"
  [responsiveOptions]="scatterResponsiveOptions" class="height-300">
</x-chartist>